import React, { useEffect } from 'react';
import { AutomaticWithdrawalsPending } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/AutomaticWithdrawalsPending/AutomaticWithdrawalsPending';
import { AutomaticWithdrawalsProcessed } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Processed/AutomaticWithdrawalsProcessed/AutomaticWithdrawalsProcessed';
import {
    AutomaticWithdrawalsWrapper,
    HeaderSection,
    SelectedTabFilterItem,
    SelectedTabFilterWrapper,
    MainContent,
} from 'src/components/FraudAndCompliance/AutomaticWithdrawals/AutomaticWithdrawals.style';
import { useAppStateContext } from 'src/AppState/AppState';
import { HeaderAndSearch } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/CommonParts/HeaderAndSearch/HeaderAndSearch';
import { SwitcherSet } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/SwitcherSet';
import { observer } from 'mobx-react-lite';

export class SearchState {}

export const AutomaticWithdrawals = observer(() => {
    const { automaticWithdrawalState } = useAppStateContext();

    // refresh list on entering Automatic Withdrawal tab
    useEffect(() => {
        automaticWithdrawalState.refresh().catch((error) => {
            console.error(error);
        });
    }, []);

    const checkBoxValue = automaticWithdrawalState.automaticWithdrawalSwitchValue;
    const { selectedTab, selectFilterPending, selectFilterProcessed } = automaticWithdrawalState;
    const blockTitle = selectedTab;
    return (
        <AutomaticWithdrawalsWrapper>
            <HeaderSection>
                {checkBoxValue === null ? null : <SwitcherSet value={checkBoxValue} />}
                <SelectedTabFilterWrapper>
                    <SelectedTabFilterItem
                        isActive={selectedTab === 'pending'}
                        onClick={selectFilterPending}
                        data-test='pending-tab'
                    >
                        Pending
                    </SelectedTabFilterItem>
                    <SelectedTabFilterItem
                        isActive={selectedTab === 'processed'}
                        onClick={selectFilterProcessed}
                        data-test='processed-tab'
                    >
                        Processed
                    </SelectedTabFilterItem>
                </SelectedTabFilterWrapper>
            </HeaderSection>
            <MainContent>
                <HeaderAndSearch
                    blockTitle={blockTitle}
                    placeholder='Search by Account Number'
                    min={0}
                />
                {selectedTab === 'pending' ? <AutomaticWithdrawalsPending /> : <AutomaticWithdrawalsProcessed />}
            </MainContent>
        </AutomaticWithdrawalsWrapper>
    );
});
